import { Button, required, SelectInput, useNotify, useRefresh } from "react-admin";
import FormModal from "server/components/Modals/FormModal";
import Edit from "@mui/icons-material/Edit";
import { useEffect, useState } from "react";
import { useWatch } from "react-hook-form";
import { CourseChoices } from "utils/choices";
import { studentRequests } from "api/studentApi";
import dataProvider from "server/dataProvider";

const CourseField = ({ currentCourse, onChangedChange }) => {
  const selectedCourse = useWatch({ name: "newCourse" });

  useEffect(() => {
    onChangedChange(selectedCourse !== currentCourse);
  }, [selectedCourse, currentCourse, onChangedChange]);

  return (
    <SelectInput
      source="newCourse"
      label="Курс"
      optionValue="id"
      optionText="name"
      choices={CourseChoices}
      validate={required()}
      fullWidth
    />
  );
};

const ChangeCourseModal = ({ record }) => {
  const notify = useNotify();
  const refresh = useRefresh();
  const [isCourseChanged, setIsCourseChanged] = useState(false);

  const handleSent = async data => {
    await dataProvider.customRequest(
      studentRequests.updateStudentCourse(record.id),
      { newCourse: data.newCourse },
      "PUT",
    );
    refresh();
    notify("Успешна редакция на курс", { type: "success" });
  };

  return (
    <FormModal
      titleContent="Редакция на курс"
      onConfirm={handleSent}
      defaultValues={{ newCourse: record.course }}
      confirmEnabled={isCourseChanged}
      resetProps={() => setIsCourseChanged(false)}
      triggerButton={
        <Button
          label="Редакция на курс"
          variant="contained"
          startIcon={<Edit />}
        />
      }
    >
      <CourseField
        currentCourse={record.course}
        onChangedChange={setIsCourseChanged}
      />
    </FormModal>
  );
};

export default ChangeCourseModal;
